import { render, staticRenderFns } from "./Buy_pay.vue?vue&type=template&id=7aab609e&scoped=true"
import script from "./Buy_pay.vue?vue&type=script&lang=js"
export * from "./Buy_pay.vue?vue&type=script&lang=js"
import style0 from "./Buy_pay.vue?vue&type=style&index=0&id=7aab609e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab609e",
  null
  
)

export default component.exports